import React, { useContext, useEffect, useState } from 'react';
import { OptionsProps, SPEED_OPTION } from './interface';
import {
  InfoIcon,
  InfoText,
  Welcome,
  OptionCard,
  OptionIcon,
  OptionInfo,
  OptionContent,
  OptionTitle,
  OptionDescription,
  RadioCircle,
} from './Elements';
import { FormattedMessage } from 'react-intl';
import {
  archTypeIcon,
  cameraIcon,
  fasttrackIcon,
  infoIcon,
} from '../../assets/Images';
import Events from './Events';
import { Button } from '../Common/Button';

export function SpeedOptions(props: OptionsProps) {

  const { emitter } = props;
  // const shopSettings = useContext(ShopSettingsContext);
  const [ selectedOption, setSelectedOption ] = useState('');
  const [ continueEnabled, setContinueEnabled ] = useState(false);

  const handleContinue = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    console.log('continue clicked');
    // setContinueEnabled(false);
    // setCurrentOptions(measureOptions);
    emitter.emit(Events.onSpeedOptionConfirm, selectedOption);
    emitter.emit(Events.onContinuePress);
  }

  const handleStandardSelect = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    setSelectedOption(SPEED_OPTION.STANDARD);
    emitter.emit(Events.onSpeedOptionSelect, SPEED_OPTION.STANDARD);
    setContinueEnabled(true);
  };

  const handleFastTrackSelect = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    setSelectedOption(SPEED_OPTION.FAST_TRACK);
    emitter.emit(Events.onSpeedOptionSelect, SPEED_OPTION.FAST_TRACK);
    setContinueEnabled(true);
  };

  return(
    <>
    <Welcome>
      <FormattedMessage
        id="drv.input-selection.speed-options.title"
        values={{
          br: <br />,
        }}
      />
    </Welcome>
    <InfoText>
      <FormattedMessage
        id="drv.input-selection.speed-options.info1"
        values={{
          br: <br />,
        }}
      />
    </InfoText>
    <OptionCard
      id="option-mobile"
      onClick={handleStandardSelect}
      className={selectedOption === SPEED_OPTION.STANDARD ? 'selected' : ''}
    >
        <OptionIcon src={cameraIcon} alt="Mobile"/>
        <OptionContent>
          <OptionTitle>
          <FormattedMessage id="drv.input-selection.option.standard-track.title" />
          </OptionTitle>
          <OptionDescription className="height-auto">
          <FormattedMessage id="drv.input-selection.option.standard-track.description" />
          </OptionDescription>
        </OptionContent>
        <RadioCircle className="radio-circle" />
    </OptionCard>
    <OptionCard
      id="option-mobile"
      onClick={handleFastTrackSelect}
      className={selectedOption === SPEED_OPTION.FAST_TRACK ? 'selected' : ''}
    >
        <OptionIcon src={fasttrackIcon} alt="Mobile"/>
        <OptionContent>
          <OptionTitle>
          <FormattedMessage id="drv.input-selection.option.fast-track.title" />
          </OptionTitle>
          <OptionDescription className="height-auto">
            <FormattedMessage id="drv.input-selection.option.fast-track.description" />
          </OptionDescription>
          <OptionInfo>
            <InfoIcon src={infoIcon} alt="Mobile"/>
            <FormattedMessage id="drv.input-selection.option.fast-track.info" />
          </OptionInfo>
        </OptionContent>
        <RadioCircle className="radio-circle" />
    </OptionCard>
    <InfoText>
      <FormattedMessage
        id="drv.input-selection.speed-options.info2"
        values={{
          br: <br />,
        }}
      />
    </InfoText>
    <Button
      disabled={ continueEnabled ? false : true }
      onClick={handleContinue} type="button"
      className="wide-primary">
      <FormattedMessage id="lp.hartmann.input-selection.continue" />
    </Button>
    </>
  )
}
